@import (reference) '../../../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.body {
  display: flex;
  flex-direction: column;
  gap: @space-16;
  padding: @space-16;
  font-size: 12px;
  min-height: 220px;
  color: var(--default--text-color--17);

  .label {
    font-size: 14px;
    margin-left: @space-4;
  }

  .title {
    margin-bottom: @space-8;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: @space-4;
  }

  .currency-input {
    width: 100%;
    height: 48px;
    font-size: 24px;
    border: 1px solid var(--default--background-color--15);
    input {
      font-size: 24px;
      color: var(--default--text-color--17);
    }
  }
  .amount {
    font-size: 20px;
  }
  .zero-balance {
    color: var(--inline-message--error--text-color);
  }

  .note-text {
    font-size: 12px;
    margin-top: @space-4;
    margin-bottom: @space-8;
    color: var(--default--text-color--15);

    .hint {
      color: var(--default--border-color--8);
    }
  }

  .amount-error {
    background-color: var(--inline-message--error--text-color);
    height: 24px;
    width: 390px;
    margin-top: 1px;
    display: flex;
    align-items: center;
  }
  .error-icon {
    margin-right: @space-4;
    color: var(--inline-message--error--text-color);
    height: 16px;
    width: 16px;
    margin-left: @space-4;
  }
  .error-border {
    border: 1px solid var(--inline-message--error--text-color);
  }

  .number-input-container {
    display: flex;
    align-items: center;
  }

  .number-input {
    width: 56px;
    height: 32px;
  }

  .input-margin {
    margin-top: @space-8;
  }
}

.background {
  background-color: var(--default--button--background-color--2);
  box-shadow: none;
  border-bottom: 1px solid var(--table-cell--divider--border-color);
}

.modal {
  width: 600px;
  min-height: 320px;
}

.default-checkbox {
  margin-top: @space-8;
}
.error-message {
  margin-bottom: @space-8;
}
.error-message-items {
  display: flex;
  flex-direction: column;
  gap: @space-8;
}

.buttons-container {
  display: flex;
  flex-direction: column;
  gap: @space-8;
  max-width: 66%;
}

.spending-limit-button {
  margin-top: @space-8;
}

.summary {
  margin: @space-8 0;
}
